import { MapboxLayerService } from '@/modules/ta/legacy/widget/services/types/MapboxLayerService';
import { COUNTRY } from '@/modules/ta/legacy/widget/mapbox.constants';

export class MapboxCountryLayerService extends MapboxLayerService {
  constructor(widget) {
    super(widget, COUNTRY);
  }

  getData(data = []) {
    return data
      .filter((row) => row.geocode0)
      .map((row) => {
        const countryCode =
          row.geocode0?.toUpperCase() || row[this.groupedColumn.field]?.toUpperCase();
        return {
          name: countryCode,
          value: parseInt(String(row[this.column.field]).replace(/,/g, ''), 10),
        };
      })
      .sort((a, b) => b.value - a.value);
  }
}
